/** Admin UI configs: statuses, filters, tabs. */
import { getRoleLabel, roleKind } from '@/utils/role-label-utils';

/** Filter group IDs for the admins {@link DataTable} configure panel. */
export const ADMIN_FILTER_GROUP_IDS = [
  'filter-status',
  'filter-establishment',
  'filter-program',
  'filter-department',
  'filter-search',
  'filter-dates',
] as const;

/** Filter group ID union for the admins {@link DataTable} configure panel. */
export type FilterGroupId = (typeof ADMIN_FILTER_GROUP_IDS)[number];

/** Human-readable label per filter group (configure panel). */
export const FILTER_GROUP_LABELS: Record<FilterGroupId, string> = {
  'filter-status': 'Statut',
  'filter-establishment': 'Établissement',
  'filter-program': 'Programme',
  'filter-department': 'Département',
  'filter-search': 'Recherche',
  'filter-dates': 'Date de création',
};

/** Admin list filter state. */
export interface AdminFilters {
  statuses: string[];
  establishmentId?: string;
  programIds?: string[];
  departmentCodes?: string[];
  searchQuery?: string;
  dateRange?: 'all' | 'week' | 'month' | 'year';
  customDateFrom?: Date;
  customDateTo?: Date;
}

/** Default admin list filters. */
export const DEFAULT_ADMIN_FILTERS: AdminFilters = {
  statuses: [],
  establishmentId: undefined,
  programIds: undefined,
  departmentCodes: undefined,
  searchQuery: '',
  dateRange: 'all',
  customDateFrom: undefined,
  customDateTo: undefined,
};

/** Tab colors for the Admins section and management page. Roles are dynamic; only the All tab is static. */
export const ADMIN_TAB_COLORS: Record<string, string> = {
  all: 'var(--color-5-nuance-1)',
};

/**
 * Strips the mode suffix from a role code to get its base category.
 * e.g. "coordinator_remote" → "coordinator"
 */
export function getAdminRoleCategory(code: string): string {
  return roleKind(code);
}

export {
  DATE_RANGE_PERIOD_OPTIONS,
  STAFF_STATUS_CONFIG,
  STAFF_STATUS_FORM_OPTIONS,
} from '@/constants/shared-catalog';

/** Default role label shown on the admin create form. */
export function getAdminFormDefaultRoleLabel(): string {
  return getRoleLabel('admin');
}

/** React Query keys invalidated after an admin create / save. */
export const ADMIN_FORM_QUERY_KEYS = {
  roles: ['roles'] as const,
  admin: (id: string) => ['admins', id] as const,
  currentManager: (id: string) => ['admin', id] as const,
};
